import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingRoutingModule } from './landing-routing.module';
import { LandingComponent } from './pages/landing/landing.component';
import { LandingSectionComponent } from './components/landing-section/landing-section.component';
import { LandingBannerComponent } from './components/landing-banner/landing-banner.component';
import { RpcControlsModule } from '@core-controls/controls.module';

import { LandingSearchComponent } from './components/landing-search/landing-search.component';
import { SearchModule } from '@search/search.module';
import { locale as english } from './i18n/en';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationLoaderService } from '@core-services/translation-loader.service';
import { ViewBaseModule } from '@view-base/view-base.module';
import { RpcPipesModule } from '@core-pipes/pipes.module';
import { ListingsModule } from '@listings/listings.module';
import { FoldersModule } from '@folders/folders.module';

import { LandingAppointmentCardComponent } from './components/landing-appointment-card/landing-appointment-card.component';
import { LandingMessageCardComponent } from './components/landing-message-card/landing-message-card.component';
import { LandingOpenHouseCardComponent } from './components/landing-open-house-card/landing-open-house-card.component';
import { AdditionalFooterModule } from '@core-layout/additional-footer/additional-footer.module';
import { LandingToolbarComponent } from './components/landing-toolbar/landing-toolbar.component';
import { LogoModule } from '@core-layout/logo/logo.module';
import { UsersModule } from '@users/users.module';
import { RpcDirectivesModule } from '@core-directives/directives.module';
import { StatusBarModeDirective } from '@core-directives/status-bar-mode/status-bar-mode.directive';

@NgModule({
    imports: [
    LandingRoutingModule,
    CommonModule,
    StatusBarModeDirective,
    TranslateModule,
    LogoModule,
    RpcControlsModule,
    SearchModule,
    RpcPipesModule,
    ViewBaseModule,
    ListingsModule,
    FoldersModule,
    AdditionalFooterModule,
    UsersModule,
    RpcDirectivesModule,
    LandingComponent,
    LandingSectionComponent,
    LandingBannerComponent,
    LandingSearchComponent,
    LandingAppointmentCardComponent,
    LandingMessageCardComponent,
    LandingOpenHouseCardComponent,
    LandingToolbarComponent
]
})
export class LandingModule {
    constructor(private readonly translationLoaderService: TranslationLoaderService) {
        this.translationLoaderService.loadTranslations(english);
    }
}
